import { render, staticRenderFns } from "./DetailsVoucher.vue?vue&type=template&id=d6c78622"
import script from "./DetailsVoucher.vue?vue&type=script&lang=js"
export * from "./DetailsVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports